export default {
    roomInfoModuleName: 'setting',
    params: { // UI에 보여만 주는 경우가 아닌, 실제로 API로 전송될 값
        roomTitle: String,
        definePasswd: Boolean,
        passwd: '',
        defaultRoleId: String,
        defaultDeviceType: String,
        defaultRoleCamera: Boolean,
        defaultRoleMic: Boolean,
        defaultRoleReset: Boolean,
        useWaitingMode: Boolean,
        isDeviceRequired: Boolean,
        isChatMode: Boolean,
        videoQuality: String,
        useQnA: Boolean,
        useQnAShare: Boolean,
        webinarType: String,
        videoLayout: String,
        // live: Boolean // deprecated
    },
}